"use strict";
exports.__esModule = true;
exports.createRange = void 0;
var createRange = function (start, end) {
    var range = [];
    for (var i = start; i <= end; i++) {
        range.push(i);
    }
    return range;
};
exports.createRange = createRange;
//# sourceMappingURL=utils.js.map